import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearBuffer } from '../../actions/buffer';

const initialState = null as Surcharge[] | null;

const slice = createSlice({
  name: '$bufferDeliverySurcharges',
  initialState,
  reducers: {
    setBufferDeliverySurcharges(
      state,
      action: PayloadAction<Surcharge[] | null>,
    ) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(clearBuffer, (state, action) => {
      return initialState;
    });
  },
});

export const { setBufferDeliverySurcharges } = slice.actions;
export default slice.reducer;
